<template>
  <div class="detail-cnt">
    <header class="inner-head">
      <span class="icon-Btn" @click="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
          <path
            d="M7.993 14.119c.395.432.4 1.127.007 1.558-.39.429-1.019.434-1.418-.004L.297 8.779c-.393-.43-.4-1.122 0-1.56L6.582.326C6.975-.105 7.607-.11 8 .32c.39.428.392 1.121-.007 1.559L3.414 6.902h13.584C17.55 6.902 18 7.39 18 8c0 .606-.452 1.097-1.002 1.097H3.414l4.58 5.023z"
          />
        </svg>
      </span>

      <h2>{{$t('taskDetail')}}</h2>
    </header>

    <section class="mid-cnt">
      <div class="dtl-postbox">
        <h1>{{taskDetail.title}}</h1>
        <div class="info-box" v-if="taskDetail.delivery_time">
          <h2>{{$t('taskCompletionTime')}}:</h2>
          <p>{{ taskDetail.delivery_time.slice(0, taskDetail.delivery_time.indexOf('T')) }}</p>
        </div>
        <div class="info-box">
          <h2>{{$t('earning')}}:</h2>
          <p>&#8377; {{taskDetail.payment}} {{$t('perTaskCompleted')}}</p>
        </div>
        <div class="info-box">
          <h2>{{$t('totalAvailableTask')}}:</h2>
          <p>{{Math.trunc(taskDetail.no_of_task - taskDetail.number_of_task_accepted)}}</p>
        </div>

        <div class="info-box">
          <h2>{{$t('totalCompletedTask')}}:</h2>
          <p>{{taskDetail.no_of_task_completed}}</p>
        </div>
      </div>
      <div
        class="how-workbox"
        v-if="taskDetail.task_details && taskDetail.task_details[0].length > 0"
      >
        <h3>{{$t('howToCompleteTasks')}}</h3>
        <div v-html="(taskDetail.task_details[0][0].text)"></div>

        <div v-if="taskDetail.task_fam === 'Mall91 Sales'" class="go-to-prod">
          <button type="button" @click="goToProdOpen(taskDetail.deep_link)">{{$t('goToProduct')}}</button>
        </div>
      </div>

      <div
        v-if="taskDetail.task_fam === 'Call Center' && ([1,2].includes(callStatus.status) || !callStatus.hasOwnProperty('id') ) && isNextTask && !$route.query.orderId"
        class="go-to-prod"
      >
        <button
          type="button"
          @click="getTaskToPay(taskDetail.Task_id, taskDetail.security_fee[0])"
          v-if="isEligible.eligible_for == false"
        >{{$t('payRegisterationFees')}}</button>
        <button
          type="button"
          @click="getTaskFunc()"
          v-if="isEligible.eligible_for == true"
        >{{$t('getTask')}}</button>
      </div>
      <div
        v-if="taskDetail.task_fam === 'Call Center' && callStatus.status === 0 && !isNextTask && !$route.query.orderId"
        class="order_action go-to-prod"
      >
        <p>{{$t('orderAcceptedOrRejected')}}</p>
        <ul class="call_detail_item" v-if="callStatus" style="padding:0 15px">
          <li>
            <span>{{$t('name')}} :</span>
            {{callStatus.buyerName}}
          </li>
          <li>
            <span>{{$t('OrderId')}} :</span>
            {{callStatus.orderId}}
          </li>
          <li>
            <span>{{$t('productName')}} :</span>
            {{callStatus.itemName}}
          </li>
          <li>
            <span>{{$t('phoneNumber')}} :</span>
            {{callStatus.PhoneNumber}}
          </li>
          <li>
            <span>{{$t('amount')}} :</span>
            {{callStatus.orderAmount}}
          </li>
          <li>
            <span>{{$t('address')}} :</span>
            {{callStatus.Address}} {{callStatus.City}}
          </li>
          <li>
            <span>{{$t('pincode')}} :</span>
            {{callStatus.Pincode}}
          </li>
        </ul>
        <div v-if="callStatus.status" style="color:green">
          Order status:
          <strong>{{getText(callStatus.status)}}</strong>
        </div>
        <div v-else style="padding:0 15px 15px 15px">
          <button type="button" @click="acceptedOrder(callStatus.id)">{{$t('orderAccepted')}}</button>
          <button type="button" class="deny" @click="denyOrder(callStatus.id)">{{$t('orderDenied')}}</button>
        </div>
      </div>
      <div
        v-if="taskDetail.task_fam === 'Call Center' && $route.query.orderId && $route.query.pendingTaskIndex"
        class="order_action go-to-prod"
      >
        <p>{{$t('orderAcceptedOrRejected')}}</p>
        <ul class="call_detail_item" v-if="callOrderId" style="padding:0 15px">
          <li>
            <span>{{$t('name')}} :</span>
            {{callOrderId.buyerName}}
          </li>
          <li>
            <span>{{$t('OrderId')}} :</span>
            {{callOrderId.orderId}}
          </li>
          <li>
            <span>{{$t('productName')}} :</span>
            {{callOrderId.itemName}}
          </li>
          <li>
            <span>{{$t('phoneNumber')}} :</span>
            {{callOrderId.PhoneNumber}}
          </li>
          <li>
            <span>{{$t('amount')}} :</span>
            {{callOrderId.orderAmount}}
          </li>
          <li>
            <span>{{$t('address')}} :</span>
            {{callOrderId.Address}} {{callOrderId.City}}
          </li>
          <li>
            <span>{{$t('pincode')}} :</span>
            {{callOrderId.Pincode}}
          </li>
        </ul>

        <div v-if="callOrderId.status===0" style="padding:0 15px 15px 15px">
          <button type="button" @click="acceptedOrder(callOrderId.id)">{{$t('orderAccepted')}}</button>
          <button
            type="button"
            class="deny"
            @click="denyOrder(callOrderId.id)"
          >{{$t('orderDenied')}}</button>
        </div>
        <div v-else style="color:green">
          Order status:
          <strong v-if="callOrderId.status === 1">Order Accepted</strong>
          <strong v-if="callOrderId.status === 2">Order Denied</strong>
        </div>
      </div>

      <div class="task-submit">
        <h2>{{$t('seeInvideo')}}</h2>
        <div class="video-box">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/McqKpz1RDIM"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div v-if="taskDetail.task_fam !== 'Call Center'">
          <button
            class="button submit-btn"
            @click="acceptModal = !acceptModal"
            v-if="this.$route.query.allTaskIndex"
          >{{$t('acceptThisTask')}}</button>
          <button
            class="button submit-btn"
            @click="submitTask(taskDetail.Task_id)"
            v-if="this.$route.query.pendingTaskIndex"
          >{{$t('submitYourTask')}}</button>
          <router-link
            tag="div"
            class="next-task"
            :to="{ path: '/'}"
            v-if="this.$route.query.allTaskIndex"
          >
            <span>{{$t('rejectThisTask')}}</span>
          </router-link>
        </div>
      </div>
    </section>
    <div class="customModal" v-if="acceptModal">
      <div class="modal_dialog">
        <div class="modal_content">
          <h3>{{$t('doYouReallyWantToAccept')}}</h3>
        </div>
        <div class="modal_footer alert_btn">
          <button type="button" class="no" @click="acceptModal = !acceptModal">{{$t('later')}}</button>
          <button type="button" class="yes" @click="acceptTask(taskDetail.Task_id)">{{$t('yes')}}</button>
        </div>
      </div>
    </div>
    <div class="payment_action" v-if="$route.query.success === 'true' && isPayment">
      <div class="order_confirmation success">
        <img src="../assets/images/check-mark-success.gif" alt="payment-success" />
        <span class="congratsText">{{$t('paymentSuccessFull')}}</span>
        <span
          class="close"
          @click="isPayment = !isPayment"
          style="position: absolute;top: 15px;right: 15px;"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 14">
            <path
              fill="#727272"
              d="M11.952 2.048c-2.73-2.73-7.173-2.73-9.904 0-2.73 2.73-2.73 7.173 0 9.904 2.73 2.73 7.173 2.73 9.904 0 2.73-2.73 2.73-7.174 0-9.904zm-2.19 7.714c-.21.21-.552.21-.762 0l-2-2-2.095 2.095c-.21.21-.551.21-.762 0-.21-.21-.21-.552 0-.762L6.238 7l-2-2c-.21-.21-.21-.552 0-.762.21-.21.552-.21.762 0l2 2 1.905-1.904c.21-.21.551-.21.761 0 .21.21.21.551 0 .761L7.762 7l2 2c.21.21.21.551 0 .762z"
            />
          </svg>
        </span>
      </div>
    </div>
    <div class="payment_action" v-if="$route.query.success === 'false' && isPayment">
      <div class="order_confirmation success">
        <img src="../assets/images/payment-failed.svg" alt="payment-success" />
        <span class="congratsText">{{$t('paymentUnSuccessFull')}}</span>
        <span
          class="close"
          @click="isPayment = !isPayment"
          style="position: absolute;top: 15px;right: 15px;"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 14">
            <path
              fill="#727272"
              d="M11.952 2.048c-2.73-2.73-7.173-2.73-9.904 0-2.73 2.73-2.73 7.173 0 9.904 2.73 2.73 7.173 2.73 9.904 0 2.73-2.73 2.73-7.174 0-9.904zm-2.19 7.714c-.21.21-.552.21-.762 0l-2-2-2.095 2.095c-.21.21-.551.21-.762 0-.21-.21-.21-.552 0-.762L6.238 7l-2-2c-.21-.21-.21-.552 0-.762.21-.21.552-.21.762 0l2 2 1.905-1.904c.21-.21.551-.21.761 0 .21.21.21.551 0 .761L7.762 7l2 2c.21.21.21.551 0 .762z"
            />
          </svg>
        </span>
      </div>
    </div>
    <section class="payment_action" v-if="call_detail">
      <div class="find-call">
        <span
          class="close"
          @click="getCallActivation(callingDetails.id)"
          v-if="callingDetails.hasOwnProperty('id')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 14">
            <path
              fill="#727272"
              d="M11.952 2.048c-2.73-2.73-7.173-2.73-9.904 0-2.73 2.73-2.73 7.173 0 9.904 2.73 2.73 7.173 2.73 9.904 0 2.73-2.73 2.73-7.174 0-9.904zm-2.19 7.714c-.21.21-.552.21-.762 0l-2-2-2.095 2.095c-.21.21-.551.21-.762 0-.21-.21-.21-.552 0-.762L6.238 7l-2-2c-.21-.21-.21-.552 0-.762.21-.21.552-.21.762 0l2 2 1.905-1.904c.21-.21.551-.21.761 0 .21.21.21.551 0 .761L7.762 7l2 2c.21.21.21.551 0 .762z"
            />
          </svg>
        </span>
        <div class="call_detail go-to-prod">
          <h5>{{$t('orderDetail')}}</h5>
          <ul class="call_detail_item">
            <li>
              <span>{{$t('name')}} :</span>
              {{callingDetails.buyerName}}
            </li>
            <li>
              <span>{{$t('OrderId')}} :</span>
              {{callingDetails.orderId}}
            </li>
            <li>
              <span>{{$t('productName')}} :</span>
              {{callingDetails.itemName}}
            </li>
            <li>
              <span>{{$t('phoneNumber')}} :</span>
              {{callingDetails.PhoneNumber}}
            </li>
            <li>
              <span>{{$t('amount')}} :</span>
              {{callingDetails.orderAmount}}
            </li>
            <li>
              <span>{{$t('address')}} :</span>
              {{callingDetails.Address}} {{callingDetails.City}}
            </li>
            <li>
              <span>{{$t('pincode')}} :</span>
              {{callingDetails.Pincode}}
            </li>
          </ul>
          <button
            type="button"
            @click="makeCall(callingDetails.id)"
            v-if="callingDetails.hasOwnProperty('id') && isEligible.eligible_for == true"
          >
            <span>{{$t('makecall')}}</span>
          </button>
        </div>
      </div>
    </section>

    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
    <div class="loader" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>
<script>
import "../assets/css/task-detail.css";
import ApiCaller from "../utils/apicaller";
import constant from "../utils/constant";
import { mapGetters } from "vuex";
import CustomToaster from "../components/Common/CustomToaster";
import { SessionHelper, X_AUTH_ID } from "../utils/session";

export default {
  name: "TaskDetail",
  components: {
    CustomToaster
  },
  data() {
    return {
      taskDetail: [],
      acceptModal: false,
      loading: false,
      selected: [],
      isValidDetail: false,
      toasterData: {},
      TaskIndex: 0,
      taskDescription: [],
      isEligible: {},
      callingDetails: {},
      getUserDetail: {},
      call_detail: false,
      isPayment: true,
      callOrderId: {},
      callStatus: {},
      isNextTask: true
    };
  },
  computed: {
    ...mapGetters(["allTasks", "pendingTasks"])
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goToMyTaskTab() {
      this.$cookie.set("taskStatus", "myTask");
      this.$router.push("/");
    },
    getText(orderStatus) {
      let obj = constant.GETTEXT;
      return obj[orderStatus];
    },
    goToProdOpen(data) {
      try {
        JSBridgePlugin.genericIntentLaunch(data);
      } catch (err) {
        console.log(err);
      }
    },
    getTaskDetail() {
      this.loading = true;
      if (this.$route.query.allTaskIndex) {
        this.TaskIndex = this.$route.query.allTaskIndex;
      } else if (this.$route.query.pendingTaskIndex) {
        this.TaskIndex = this.$route.query.pendingTaskIndex;
      }
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/taskdetails/?task_id=" + this.TaskIndex,
        "get"
      )
        .then(data => {
          if (data.eligible_for && data.data[0].task_fam === "Call Center") {
            this.getUserDetailObject();
          }
          this.getCallStatus();
          this.isEligible = data;
          this.taskDetail = data.data[0];
          this.taskDescription = data.data[0].task_details[0][0].text.split(
            "\r\n"
          );
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },

    getCallActivation(id) {
      const obj = {
        call_id: id
      };
      ApiCaller(constant.BASE_API_URL, "tasks/call_order_active/", "post", obj)
        .then(data => {
          this.call_detail = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getTaskToPay(id, amount) {
      this.loading = true;
      window.location.href = `https://test4.services-money91.com/parttime/payment/gateway/?gateway_amount=${amount}&Task-Id=${id}&x_auth_id=${SessionHelper.getCookie(
        X_AUTH_ID
      )}`;
    },
    getTaskFunc() {
      if (
        this.$route.query.allTaskIndex ||
        this.$route.query.pendingTaskIndex
      ) {
        this.getCallingDetails();
      }
    },
    makeCall(id) {
      this.loading = true;
      if (this.callingDetails) {
        const obj = {
          call_id: id
        };
        ApiCaller(constant.BASE_API_URL, "tasks/makecall/", "post", obj)
          .then(data => {
            this.loading = false;
            this.call_detail = false;
            try {
              JSBridgePlugin.genericIntentLaunch(
                `tel:+91${this.callingDetails.PhoneNumber}`
              );
            } catch {
              console.log("error");
            }
            this.getCallStatus();
          })
          .catch(err => {
            // this.toasterData = {
            //   msg: err.response.data.message,
            //   color: "#ff4643",
            //   iconName: "error"
            // };
            // this.isValidDetail = true;
            this.call_detail = false;
            this.loading = false;
          });
      }
    },
    getCallingDetails() {
      this.loading = true;
      if (
        this.$route.query.allTaskIndex ||
        this.$route.query.pendingTaskIndex
      ) {
        const task_id =
          this.$route.query.allTaskIndex || this.$route.query.pendingTaskIndex;
        ApiCaller(
          constant.BASE_API_URL,
          "tasks/calling_details/?task_id=" + task_id,
          "get"
        )
          .then(data => {
            this.callingDetails = data.data;
            this.call_detail = true;
            this.loading = false;
          })
          .catch(err => {
            this.toasterData = {
              msg: err.response.data.message,
              color: "#ff4643",
              iconName: "error"
            };
            this.isValidDetail = true;
            this.loading = false;
          });
      }
    },
    acceptedOrder(id) {
      this.loading = true;
      const obj = {
        call_id: id,
        status: 1
      };
      ApiCaller(constant.BASE_API_URL, "tasks/accept_or_deny/", "post", obj)
        .then(data => {
          if (data.success) {
            this.call_detail = false;
            this.isNextTask = !this.isNextTask;
            this.getTaskDetail();
            if (this.$route.query.orderId) {
              ApiCaller(
                constant.BASE_API_URL,
                "tasks/orders/" + "?order_id=" + this.$route.query.orderId,
                "get"
              )
                .then(data => {
                  this.loading = false;
                  this.callOrderId = data.data[0].extra;
                })
                .catch(err => {
                  this.loading = false;
                });
            }
          }
          this.loading = false;
        })
        .catch(err => {
          this.toasterData = {
            msg: err.response.data.message,
            color: "#ff4643",
            iconName: "error"
          };
          this.isValidDetail = true;
          this.loading = false;
        });
    },
    denyOrder(id) {
      this.loading = true;
      const obj = {
        call_id: id,
        status: 2
      };
      ApiCaller(constant.BASE_API_URL, "tasks/accept_or_deny/", "post", obj)
        .then(data => {
          this.loading = false;
          if (data.success) {
            this.call_detail = false;
            this.isNextTask = !this.isNextTask;
            this.getTaskDetail();
            if (this.$route.query.orderId) {
              ApiCaller(
                constant.BASE_API_URL,
                "tasks/orders/" + "?order_id=" + this.$route.query.orderId,
                "get"
              )
                .then(data => {
                  this.loading = false;
                  this.callOrderId = data.data[0].extra;
                })
                .catch(err => {
                  this.loading = false;
                });
            }
          }
        })
        .catch(err => {
          this.toasterData = {
            msg: err.response.data.message,
            color: "#ff4643",
            iconName: "error"
          };
          this.isValidDetail = true;
          this.loading = false;
        });
    },
    getUserDetailObject() {
      this.loading = true;
      ApiCaller(constant.BASE_API_URL, "user/userdetails/", "get")
        .then(data => {
          this.loading = false;
          this.getUserDetail = data.data;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },

    acceptTask(id) {
      this.loading = true;
      const obj = {
        task_id: id
      };
      ApiCaller(constant.BASE_API_URL, "tasks/orders/", "post", obj)
        .then(data => {
          this.loading = false;
          this.acceptModal = false;
          this.$router.push("/");
        })
        .catch(err => {
          this.loading = false;
          this.acceptModal = false;
          this.toasterData = {
            msg: err.response.data.message,
            color: "#ff4643",
            iconName: "error"
          };
          this.isValidDetail = true;
        });
    },
    submitTask(id) {
      this.$router.push("/submit-task?taskId=" + id);
    },
    getCallStatus() {
      if (
        this.$route.query.allTaskIndex ||
        this.$route.query.pendingTaskIndex
      ) {
        const task_id =
          this.$route.query.allTaskIndex || this.$route.query.pendingTaskIndex;
        ApiCaller(
          constant.BASE_API_URL,
          "tasks/last_call/?task_id=" + task_id,
          "get"
        )
          .then(data => {
            this.loading = false;
            this.callStatus = data.data;
            if (data.data.status === 0) {
              this.isNextTask = !this.isNextTask;
            }
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      }
    }
  },
  mounted() {
    if (this.$route.query.orderId) {
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/orders/" + "?order_id=" + this.$route.query.orderId,
        "get"
      )
        .then(data => {
          this.loading = false;
          this.callOrderId = data.data[0].extra;
        })
        .catch(err => {
          this.loading = false;
        });
    }
    if (this.$route.query.allTaskIndex) {
      this.getTaskDetail();
    }
    if (this.$route.query.pendingTaskIndex) {
      this.getTaskDetail();
    }
    // this.getCallStatus()
    __native_money91._onResume = function() {
      _this.getTaskDetail();
    };
  }
};
</script>
<style lang="css" scoped>
.order_action button {
  width: 80%;
  margin-bottom: 14px;
}
.order_action p {
  color: #505050;
  font-size: 0.938em;
  padding-right: 35px;
  margin: 15px;
  font-weight: 600;
}
.order_action button.deny {
  background: #fff;
  border: 1px solid red;
  color: red;
}
.call_detail {
  padding: 15px;
  margin: 0;
}
.call_detail h5 {
  font-size: 1.25em;
}
.call_detail_item {
  text-align: left;
  margin: 10px 0;
}
.call_detail_item li {
  margin-bottom: 8px;
  font-size: 0.875em;
  color: #505050;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.call_detail_item li span {
  color: #000;
  font-weight: 600;
}
.find-call {
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: auto;
  max-height: 500px;
  background: #fff;
  border-radius: 15px;
}
.payment_action {
  position: fixed;
  top: 0;
  left: 0;
  /* transform: translate(-50% , -55%); */
  background: rgba(28, 28, 28, 0.43);
  right: 0;
  bottom: 0;
  z-index: 9;
}
.order_confirmation {
  position: absolute;
  transform: translate(-50%, -55%);
  text-align: center;
  top: 50%;
  left: 50%;
  background: #fff;
  width: 80%;
  text-align: center;
  border-radius: 15px;
}
.order_confirmation.success img {
  width: 50%;
  display: block;
  margin: 40px auto;
}
.order_confirmation .congratsText {
  font-size: 1.5em;
  margin-bottom: 0.75em;
  font-weight: 700;
  color: #138808;
  display: block;
}
.order_confirmation .got_order {
  font-size: 1.05em;
  margin: 5px 0;
  font-weight: 700;
  display: block;
}
</style>